import { Button } from "@material-ui/core";
import { Launch } from "@material-ui/icons";
import { memo } from "react";
import { utils, writeFile } from "xlsx";

const ExportButton = ({ data, filename, columns }) => {
  const isDisabled = data.every((item) => !item.elements.length);

  const exportToXLSX = () => {
    const rows = [];
    const headersIds = {};

    const header = [
      "",
      ...columns.map((colum) => {
        headersIds[colum.id] = colum.id;
        return colum.label;
      }),
    ];

    rows.push(header);

    data.forEach((cell) => {
      cell.elements?.forEach((item) => {
        const row = [
          "",
          ...columns.map((column) =>
            column?.format ? column.format(item[column.id]) : item[column.id]
          ),
        ];
        rows.push(row);
      });

      const totalsLabel = "Totais: ";

      rows.push([
        totalsLabel,
        ...columns.map((column) => cell.total[column.id]),
      ]);
    });

    const sheet = utils.aoa_to_sheet(rows);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, sheet, "Sheet1");
    writeFile(workbook, `${filename}.xlsx`);
  };

  return (
    <Button
      size="small"
      variant="contained"
      endIcon={<Launch />}
      style={
        isDisabled
          ? null
          : {
              backgroundColor: "#1d6f42",
              color: "#f4f4f4",
            }
      }
      onClick={exportToXLSX}
      disabled={isDisabled}
    >
      XLSX
    </Button>
  );
};

export default memo(ExportButton);
